<div class="edit-file-entity-container">
	<file-edit-header
		[activeTab]="activeTab"
		[file]="fileEntity()"
		(replaceFilePressed)="replaceFileButtonClick(fileInput)"
		(downloadFilePressed)="downloadFile()"
		(deleteFilePressed)="deleteFile()"
		(nameChanged)="editEntityName($event)"
		(activeTabChanged)="activeTab = $event"
	/>

	@if (activeTab === 'view') {
		<div class="view-tab">
			@if (fileType() === 'application/pdf' && fileClassification() === 'REPORT') {
				<div>
					<file-notification
						[incidentsDetectedAndCreated]="incidentsDetectedAndCreated()"
						[dataExists]="dataExists()"
						[fileEntity]="fileEntity()"
					/>
				</div>
			}
			<au-file-viewer
				[fileEntityPk]="fileEntity()?.pk"
				[fileData]="fileEntity().file"
				[class.blured]="replacingInProgress | async"
			/>
			@if (replacingInProgress | async) {
				<div class="spinner-wrapper">
					<mat-spinner diameter="40" />
				</div>
			}
		</div>
	}

	@if (activeTab === 'info') {
		<div>
			<edit-file-entity-form [file]="fileEntity()" />
		</div>
	}
</div>
@if (fileType() === 'application/pdf' && fileClassification() === 'REPORT') {
	<file-detection-button
		[fileEntity]="fileEntity()"
		[activeTab]="activeTab"
		(incidentsDetectedAndCreated)="incidentsDetectedAndCreated.set($event)"
		(getDataExistEmitter)="dataExists.set($event)"
	/>
}
<input #fileInput type="file" [multiple]="false" (change)="replaceFile($event)" hidden />
